import React, { CSSProperties, Fragment, useCallback, useEffect, useMemo, useState } from 'react'
import { Button, Card, Col, Form, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap';
import { ResultOperation, Column, SelfTableList, FilterState, ListFields, usePermission, useTranslation, useFetch, ChooseComponent } from '@np/np_webcomponentlib'
import { API_BUSINESS, API_OPERATIONS_VIEW } from '../../shared/consts/api'


import { ColumnEvent, ColumnWithCopyToClipboard, ColumnData } from '../../shared/entityOperations/EntityOperationsCustomFC'
import TypeOperationCheckboxList from '../../shared/MasterData/TypeOperationCheckboxList';

import {DataEntityType as BusinessType} from '../Business/BusinessTypes'
import { useNavigate } from 'react-router-dom';
import { formatAmount } from '../../shared/utils/formatAmount';
import { TypeOperationEnum, TypePaymentMethodEnum, TypeStatusOperationEnum } from '../../shared/MasterData/MasterDataTypes';
import StatusCheckboxList from '../../shared/MasterData/StatusCheckboxList';
import PaymentMethodCheckboxList from '../../shared/MasterData/PaymentMethodCheckboxList.tsx';


interface EntityData {
  business: BusinessType;
  countRequest: number;
  countOperations: number;
  countGetReq: number;
  countSuccessClient: number;
  percentSuccessClient: number;
  percentSuccessGetReq: number;
}


const DashboardConversion = ({title }: { title: string }) => {

  const [entity, setEntity] = useState<EntityData[]>([])

  const [entityMerchants, setEntityMerchants] = useState<EntityData[]>([])

  const [entityProviders, setEntityProviders] = useState<EntityData[]>([])

  const [startDate, setStartDate] = useState<Date>(new Date())
  const [endDate, setEndDate] = useState<Date>(new Date())

  const [idMerhant, setIDMerhcant] = useState<string>("")
  
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<TypePaymentMethodEnum[]>([]);

  const [selectedTypeOperations, setSelectedTypeOperations] = useState<TypeOperationEnum[]>([TypeOperationEnum.PayIn, TypeOperationEnum.PayOut]);

  const [isLoading, setIsLoading] = useState(false);

  const [, doFetchLoad] = useFetch(
    `${API_OPERATIONS_VIEW}dashboard/conversion/provider`)//{ error: errCU, isLoading: isLoadCU, response: respCU }

    const [, doFetchLoadMerchants] = useFetch(
      `${API_OPERATIONS_VIEW}dashboard/conversion/merchant`)//{ error: errCU, isLoading: isLoadCU, response: respCU }
  
    

  // const [, doFetchLoadProviders] = useFetch(
  //     `${API_OPERATIONS_VIEW}dashboard/marja/provider`)//{ error: errCU, isLoading: isLoadCU, response: respCU }

    
//   useEffect(() => {

   


//   // doFetchLoadProviders({
//   //     method: 'POST',
//   //     headers: { "Content-Type": "application/json" },
//   //     data: {
//   //       startDate: startDate,
//   //       endDate: endDate,
//   //       listTypeOperation: selectedTypeOperations
//   //   }
//   // }).then(responce => {
//   //   setEntityProviders(responce.dataList)
//   // })



// }, [startDate, endDate, selectedTypeOperations, idMerhant, selectedPaymentMethod])


const handleCreateReport = () => {
  setIsLoading(true);
  
  Promise.all([
    doFetchLoad({
      method: 'POST',
      headers: { "Content-Type": "application/json" },
      data: {
        startDate: startDate,
        endDate: endDate,
        listTypeOperation: selectedTypeOperations,
        ...(idMerhant && { idMerchant: idMerhant }),
        ListPaymentMethod: selectedPaymentMethod
      }
    }).then(responce => {
      setEntity(responce.dataList)
    }),
    
    doFetchLoadMerchants({
      method: 'POST',
      headers: { "Content-Type": "application/json" },
      data: {
        startDate: startDate,
        endDate: endDate,
        listTypeOperation: selectedTypeOperations,
        ...(idMerhant && { idMerchant: idMerhant }),
        ListPaymentMethod: selectedPaymentMethod
      }
    }).then(responce => {
      setEntityMerchants(responce.dataList)
    })
  ]).finally(() => {
    setIsLoading(false);
  });
}


  // Calculate total values for the summary row
  const totals = useMemo(() => {
    return entity.reduce(
      (acc, item) => {
        acc.countRequest += item.countRequest;
        acc.countGetReq += item.countGetReq;
        acc.countSuccessClient += item.countSuccessClient;
        return acc;
      },
      {
        countRequest: 0,
        countGetReq: 0,
        countSuccessClient: 0
      }
    );
  }, [entity]);

  const totalsMerchants = useMemo(() => {
    return entityMerchants.reduce(
      (acc, item) => {
        acc.countRequest += item.countRequest;
        acc.countGetReq += item.countGetReq;
        acc.countSuccessClient += item.countSuccessClient;
        return acc;
      },
      {
        countRequest: 0,
        countGetReq: 0,
        countSuccessClient: 0
      }
    );
  }, [entityMerchants]);

  const columnsIdrfcharacteristictype: Column[] = [

    {
      title: '',
      listFields: null,
      type: 'custom',
      custom: (data: any) => (
  
        <ColumnWithCopyToClipboard data={data.idUnique} title='fe fe-edit eventIcom'></ColumnWithCopyToClipboard>
      ),
      key: 1,
      withFilter: null,
      class: "eventColumn"
    },
  
  
    {
      title: 'Наименование',
      listFields: {
        fieldName: 'name',
        comparison: 'containsIgnoreCase',
        listVal: [''],
      },
      key: 6,
      withFilter: 'all',
    },
  
  
  
  
    {
      title: 'Дата создания',
      listFields: {
        fieldName: 'dateAdded',
        comparison: 'containsStrong',
        listVal: [''],
      },
      type: 'date-time',
      key: 100,
      withFilter: 'onlySorted',
      class: "dateTtimeColumn"
    },
  
  
    {
      title: 'Дата изменения',
      listFields: {
        fieldName: 'dateUpdated',
        comparison: 'containsStrong',
        listVal: [''],
      },
      type: 'date-time',
      key: 101,
      withFilter: 'onlySorted',
      class: "dateTtimeColumn"
    },
  
  
  
  ]
  
  const initialFilterState: FilterState = {
    listFields: [{ fieldName: "typeBusiness", comparison: "equalsStrong", listVal: ["merchant"] }],
    sort: null,
    searchData: '',
    take: 50,
    skip: 0,
  };

  return (
    <Fragment>

      <h2>{title}</h2>

      <Card>
    <Card.Header>
        <Card.Title as='h4'>{useTranslation('generateReport')}</Card.Title>
    </Card.Header>
    <Card.Body className="">
        {/* <Form className="form-horizontal"> */}

        <Col md={6}>
                <Form.Label className="col-md-3">{useTranslation('startDate')}</Form.Label>
                <Col md={9}>
                <Form.Control 
                    type="date" 
                    placeholder={useTranslation('startDate')} 
                    value={startDate ? startDate.toISOString().split('T')[0] : ''} 
                    onChange={e => setStartDate(new Date(e.target.value))} // Преобразуем строку в объект Date
                />
                </Col>
            </Col>

            <Col md={6}>
                <Form.Label className="col-md-3">{useTranslation('endDate')}</Form.Label>
                <Col md={9}>
                <Form.Control 
                    type="date" 
                    placeholder={useTranslation('endDate')} 
                    value={endDate ? endDate.toISOString().split('T')[0] : ''} 
                    onChange={e => setEndDate(new Date(e.target.value))} // Преобразуем строку в объект Date
                />
                </Col>
                </Col>

    
                </Card.Body>
                </Card>

      <TypeOperationCheckboxList
                selectedOperations={selectedTypeOperations}
                onChange={setSelectedTypeOperations}
            />

<PaymentMethodCheckboxList
                    selectedStatuses={selectedPaymentMethod}
                    onChange={setSelectedPaymentMethod}></PaymentMethodCheckboxList>
{/* 

                <Form.Label className="col-md-3">{useTranslation('provider')}</Form.Label>
                <Col md={9}>
                    <ChooseComponent
                        getDisplayDescription={(seletedData: any) => {
                            return seletedData ? seletedData.name : 'Выберите...'
                        }}
                        apiUrl={`${API_BUSINESS}business/list`}
                        columns={columnsIdrfcharacteristictype}
                        selectData={(selectData: any) => {
                          setIDMerhcant(selectData.idUnique)
                        }}
                        resetData={() => {
                          setIDMerhcant("")
                        }}
                        initIDUnique={""}
                        initialFilterState = {initialFilterState}
                    >
                        Выберите провайдера
                    </ChooseComponent>
                </Col> */}
            
      
      <Button onClick={handleCreateReport} disabled={isLoading}>
        {isLoading ? 'Загрузка...' : 'Сформировать отчет'}
      </Button>

      <h2 style={{ marginTop: "50px", marginBottom: "50px" }}>Провайдеры</h2>
      
      <TableData titleFirstColumn="Провайдеры" entity={entity} totals={totals}></TableData>


      <h2 style={{ marginTop: "50px", marginBottom: "50px" }}>Мерчанты</h2>
      
      <TableData titleFirstColumn="Мерчанты" entity={entityMerchants} totals={totalsMerchants}></TableData>


     
      
    </Fragment>
  )
}




export default DashboardConversion

const TableData = ({titleFirstColumn, entity, totals}:{titleFirstColumn: string, entity: EntityData[], totals: { countRequest: number; countGetReq: number; countSuccessClient: number; }}) => {
  const navigate = useNavigate()
  
  const fixedColumnStyle: CSSProperties = {
    width: "300px",
    whiteSpace: "normal",
    wordWrap: "break-word",
    wordBreak: "break-word",
    textAlign: "center"
  };
  
  return <table className="table table-bordered text-nowrap mb-0">

    <thead>
      <tr>
        <th style={fixedColumnStyle}>
          {titleFirstColumn}
        </th>
        <th>% выдач рек-в</th>
        <th>% успеха</th>
        <th>Всего запросов</th>
        <th>Выдач рек-в/Всего операций</th>
        <th>
          Успехи
        </th>

      </tr>
    </thead>


    <tbody>
      {entity && entity.length > 0 ? (
        entity.map((item, index) => (
          <tr key={index}>
            <td style={fixedColumnStyle}><div onClick={() => navigate("/business/" + item.business.idUnique)}>
          {item.business?.name}
        </div></td>
        <td>{formatAmount(item.percentSuccessGetReq, 2)}</td>
        <td>{item.countGetReq > 0 ? formatAmount(((item.countSuccessClient) / item.countGetReq) * 100, 2) : '0'}</td>
            <td>{formatAmount(item.countRequest, 0)}</td>
            {/* <td>{formatAmount(item.countOperations, 0)}</td> */}
            <td>{formatAmount(item.countGetReq, 0)}</td>


            <td>{formatAmount(item.countSuccessClient, 0)}</td>
            
      
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan={7} className="text-center">
            Данные не найдены
          </td>
        </tr>
      )}


      {/* Summary Row */}
      {entity && entity.length > 0 && (
        <tr>
          <td><strong>Итого</strong></td>
          <td><strong>{totals.countRequest > 0 ? formatAmount(((totals.countGetReq) / totals.countRequest) * 100, 2) : '0'}</strong></td>
          <td><strong>{totals.countGetReq > 0 ? formatAmount(((totals.countSuccessClient) / totals.countGetReq) * 100, 2) : '0'}</strong></td>
          <td><strong>{formatAmount(totals.countRequest, 0)}</strong></td>
          <td><strong>{formatAmount(totals.countGetReq, 0)}</strong></td>
          <td><strong>{formatAmount(totals.countSuccessClient, 0)}</strong></td>
        </tr>
      )}
    </tbody>

  </table>;
}
